import { useState, useEffect } from "react";
import Payment from "../ReviewAndPay/Payment/Payment";
import { LoadingIndicator } from "../../lib/iprs-react-library/src";
import saveReferral from "../PersonCapture/Referral";

// The initial GetBookingSiteConfig cannot check whether the patient already
// has a payment card on file, because at that point no case (and therefore no
// patient) exists yet — the backend just sets IsPaymentCardRequired = true
// unconditionally.  Once we have a CaseID (either pre-existing or freshly
// created by saveReferral) we call IsPaymentCardRequired so the backend can
// look up the patient's saved cards.  If a valid card is already on file we
// skip the payment form entirely, matching the behaviour of the ordinary
// (non-early) payment flow.
const checkIfPaymentCardRequired = (api, caseID) => {
    return api.transact("IsPaymentCardRequired", { caseid: caseID })
        .then(r => r.apiResult)
        .then(r => r.IsPaymentCardRequiredNew);
};

const EarlyPaymentCapture = ({ api, doUpdate, appState }) => {
    const [loading, setLoading] = useState(false);
    const [caseReady, setCaseReady] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const haveCaseID = appState?.caseID || appState?.websiteConfig?.CaseID;
        if (haveCaseID) {
            setLoading(true);
            checkIfPaymentCardRequired(api, haveCaseID)
                .then(required => {
                    if (!required) {
                        doUpdate({ CardPaymentCheckDone: true });
                    } else {
                        setCaseReady(true);
                    }
                })
                .catch(e => {
                    setError(e.message);
                })
                .finally(() => {
                    setLoading(false);
                });
            return;
        }

        setLoading(true);
        saveReferral(api, appState)
            .then(r => {
                const url = new URL(r.BookingURL);
                const token = url.searchParams.get("token");
                doUpdate({
                    ReferralComplete: true,
                    CaseID: r.CaseID,
                    CaseRef: r.CaseRef,
                    Token: token
                });
                api.setToken(token);
                return r.CaseID;
            })
            .then(caseID => checkIfPaymentCardRequired(api, caseID))
            .then(required => {
                if (!required) {
                    doUpdate({ CardPaymentCheckDone: true });
                } else {
                    setCaseReady(true);
                }
            })
            .catch(e => {
                setError(e.message);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const handlePaymentComplete = (value) => {
        if (value.CardPaymentCheckDone) {
            doUpdate({ CardPaymentCheckDone: true });
        }
    };

    if (loading) {
        return <LoadingIndicator loading={true} />;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    if (!caseReady) {
        return <LoadingIndicator loading={true} />;
    }

    return (
        <Payment
            api={api}
            handleReviewOrPay={handlePaymentComplete}
            doUpdate={doUpdate}
            appState={appState}
        />
    );
};

export default EarlyPaymentCapture;
